const mocktails = [
  {
    name: 'Red Light Free',
    ingredients: 'Maracujá Red, Suco de laranja, Limão e Espuma artesanal',
    image: 'https://public.readdy.ai/ai/img_res/dfc6cfc115b827a6721c9211b975887b.jpg',
  },
  {
    name: 'Sodas Italianas',
    ingredients: 'Soda, Syrup de Fruta',
    image: 'https://readdy.ai/api/search-image?query=italian%20soda%20tall%20glass%20with%20fruit%20syrup%20and%20ice%2C%20watercolor%20illustration%20style%2C%20pink%20red%20tones%2C%20white%20background%2C%20artistic%20drink%20painting%2C%20soft%20pastel%20colors%2C%20premium%20cocktail%20art%2C%20garnished%20with%20citrus&width=200&height=260&seq=drink2&orientation=portrait',
  },
  {
    name: 'Bramble Free',
    ingredients: 'Soda, Syrup de amora, Açucar e Limão',
    image: 'https://readdy.ai/api/search-image?query=bramble%20mocktail%20rocks%20glass%20with%20blackberry%20syrup%20purple%20violet%20color%2C%20watercolor%20illustration%20style%2C%20purple%20berry%20tones%2C%20white%20background%2C%20artistic%20drink%20painting%2C%20soft%20pastel%20colors%2C%20premium%20cocktail%20art%2C%20berries%20garnish&width=200&height=260&seq=drink3&orientation=portrait',
  },
  {
    name: 'Sweet Cloud Free',
    ingredients: 'Suco de Laranja, Limão, Syrup Maracujá Red e Algodão-doce',
    image: 'https://readdy.ai/api/search-image?query=sweet%20cloud%20mocktail%20wine%20glass%20with%20cotton%20candy%20on%20top%2C%20orange%20gradient%20drink%2C%20watercolor%20illustration%20style%2C%20warm%20orange%20amber%20tones%2C%20white%20background%2C%20artistic%20drink%20painting%2C%20soft%20pastel%20colors%2C%20premium%20cocktail%20art&width=200&height=260&seq=drink4&orientation=portrait',
  },
  {
    name: 'Caipifree',
    ingredients: 'Fruta da estação e Soda',
    image: 'https://readdy.ai/api/search-image?query=caipirinha%20style%20mocktail%20tall%20glass%20with%20strawberries%20and%20ice%2C%20watercolor%20illustration%20style%2C%20pink%20red%20tones%2C%20white%20background%2C%20artistic%20drink%20painting%2C%20soft%20pastel%20colors%2C%20premium%20cocktail%20art%2C%20fresh%20fruit%20garnish&width=200&height=260&seq=drink5&orientation=portrait',
  },
  {
    name: 'MoscowZero',
    ingredients: 'Soda, Limão, Maçã Verde, Syrup e Espuma Artesanal',
    image: 'https://readdy.ai/api/search-image?query=moscow%20mule%20copper%20mug%20mocktail%20with%20mint%20garnish%2C%20watercolor%20illustration%20style%2C%20warm%20copper%20brown%20tones%2C%20white%20background%2C%20artistic%20drink%20painting%2C%20soft%20pastel%20colors%2C%20premium%20cocktail%20art%2C%20green%20mint%20leaves&width=200&height=260&seq=drink6&orientation=portrait',
  },
];

const cocktails = [
  {
    name: 'Sweet Cloud',
    ingredients: 'Licor de Vinho, Limão, Suco de Laranja, Syrup Maracujá Red e Algodão-doce',
    image: 'https://readdy.ai/api/search-image?query=sweet%20cloud%20cocktail%20wine%20glass%20with%20cotton%20candy%20on%20top%2C%20orange%20gradient%20drink%20with%20passion%20fruit%20syrup%2C%20watercolor%20illustration%20style%2C%20warm%20orange%20amber%20tones%2C%20white%20background%2C%20artistic%20drink%20painting%2C%20soft%20pastel%20colors%2C%20premium%20cocktail%20art%2C%20elegant%20garnish&width=200&height=260&seq=cocktail1&orientation=portrait',
  },
  {
    name: 'Red Light',
    ingredients: 'Gin, Maracujá Red, Suco de laranja, Limão e Espuma artesanal e Papel Arroz personalizado',
    image: 'https://readdy.ai/api/search-image?query=red%20light%20cocktail%20elegant%20coupe%20glass%20with%20gin%20passion%20fruit%20orange%20foam%20top%2C%20deep%20red%20orange%20color%2C%20watercolor%20illustration%20style%2C%20warm%20crimson%20tones%2C%20white%20background%2C%20artistic%20drink%20painting%2C%20soft%20pastel%20colors%2C%20premium%20cocktail%20art%2C%20rice%20paper%20garnish&width=200&height=260&seq=cocktail2&orientation=portrait',
  },
  {
    name: 'Fiu-fiu Drink',
    ingredients: 'Fiu-fiu Cajazinha, Limão, Suco de laranja, Maracujá Red e Hibisco',
    image: 'https://readdy.ai/api/search-image?query=tropical%20cocktail%20tall%20glass%20with%20hibiscus%20cajazinha%20orange%20gradient%20layers%2C%20mint%20garnish%20on%20top%2C%20watercolor%20illustration%20style%2C%20warm%20amber%20orange%20tones%2C%20white%20background%2C%20artistic%20drink%20painting%2C%20soft%20pastel%20colors%2C%20premium%20cocktail%20art%2C%20tropical%20fruit%20garnish&width=200&height=260&seq=cocktail3&orientation=portrait',
  },
  {
    name: 'Caja Lemon',
    ingredients: 'Fiu-fiu Cajazinha, Limão, Água com gás, Açucar e Sal na borda',
    image: 'https://readdy.ai/api/search-image?query=caja%20lemon%20cocktail%20tall%20highball%20glass%20with%20salted%20rim%20cajazinha%20lemon%20yellow%20golden%20color%20with%20ice%2C%20watercolor%20illustration%20style%2C%20soft%20yellow%20golden%20tones%2C%20white%20background%2C%20artistic%20drink%20painting%2C%20soft%20pastel%20colors%2C%20premium%20cocktail%20art%2C%20lemon%20garnish&width=200&height=260&seq=cocktail4&orientation=portrait',
  },
  {
    name: 'Pitaya Mule',
    ingredients: 'Vodka, Syrup de framboesa, Espuma de pitaya roxa',
    image: 'https://readdy.ai/api/search-image?query=pitaya%20mule%20copper%20mug%20cocktail%20with%20purple%20dragon%20fruit%20foam%20on%20top%2C%20vibrant%20purple%20violet%20color%2C%20watercolor%20illustration%20style%2C%20deep%20purple%20magenta%20tones%2C%20white%20background%2C%20artistic%20drink%20painting%2C%20soft%20pastel%20colors%2C%20premium%20cocktail%20art%2C%20elegant%20copper%20mug&width=200&height=260&seq=cocktail5&orientation=portrait',
  },
  {
    name: 'Bramble',
    ingredients: 'Gin, Syrup de amora, Açucar e Limão',
    image: 'https://readdy.ai/api/search-image?query=bramble%20cocktail%20rocks%20glass%20with%20blackberry%20gin%20syrup%20deep%20purple%20violet%20color%20crushed%20ice%2C%20watercolor%20illustration%20style%2C%20rich%20purple%20berry%20tones%2C%20white%20background%2C%20artistic%20drink%20painting%2C%20soft%20pastel%20colors%2C%20premium%20cocktail%20art%2C%20blackberry%20garnish%20lemon&width=200&height=260&seq=cocktail6&orientation=portrait',
  },
  {
    name: 'Fitzgerald',
    ingredients: 'Gin, Angostura, Açucar e Limão',
    image: 'https://readdy.ai/api/search-image?query=fitzgerald%20cocktail%20low%20rocks%20glass%20with%20gin%20angostura%20bitters%20amber%20orange%20color%20with%20ice%2C%20watercolor%20illustration%20style%2C%20warm%20amber%20orange%20tones%2C%20white%20background%2C%20artistic%20drink%20painting%2C%20soft%20pastel%20colors%2C%20premium%20cocktail%20art%2C%20lemon%20twist%20garnish&width=200&height=260&seq=cocktail7&orientation=portrait',
  },
  {
    name: 'Whisky Sour',
    ingredients: 'Whisky, Açucar, Limão, Proteina e Angostura',
    image: 'https://readdy.ai/api/search-image?query=whisky%20sour%20cocktail%20rocks%20glass%20with%20golden%20amber%20whiskey%20foam%20top%20egg%20white%20protein%20angostura%20bitters%20drops%2C%20watercolor%20illustration%20style%2C%20warm%20golden%20amber%20tones%2C%20white%20background%2C%20artistic%20drink%20painting%2C%20soft%20pastel%20colors%2C%20premium%20cocktail%20art%2C%20lemon%20garnish&width=200&height=260&seq=cocktail8&orientation=portrait',
  },
  {
    name: 'Pinicilin',
    ingredients: 'Whisky and Honey, Ginger syrup e Limão Siciliano',
    image: 'https://readdy.ai/api/search-image?query=penicillin%20cocktail%20rocks%20glass%20with%20scotch%20whisky%20honey%20ginger%20syrup%20sicilian%20lemon%20golden%20yellow%20color%20with%20ice%2C%20watercolor%20illustration%20style%2C%20warm%20golden%20honey%20tones%2C%20white%20background%2C%20artistic%20drink%20painting%2C%20soft%20pastel%20colors%2C%20premium%20cocktail%20art%2C%20candied%20ginger%20garnish&width=200&height=260&seq=cocktail9&orientation=portrait',
  },
  {
    name: 'Negroni',
    ingredients: 'Gin, Campari e Vermouth Tinto',
    image: 'https://readdy.ai/api/search-image?query=negroni%20cocktail%20rocks%20glass%20with%20gin%20campari%20sweet%20vermouth%20deep%20ruby%20red%20color%20large%20ice%20cube%2C%20watercolor%20illustration%20style%2C%20rich%20deep%20red%20crimson%20tones%2C%20white%20background%2C%20artistic%20drink%20painting%2C%20soft%20pastel%20colors%2C%20premium%20cocktail%20art%2C%20orange%20peel%20garnish&width=200&height=260&seq=cocktail10&orientation=portrait',
  },
  {
    name: 'Paloma',
    ingredients: 'Tequila, Limão, Syrup grape fruit e Água com gás',
    image: 'https://readdy.ai/api/search-image?query=paloma%20cocktail%20tall%20highball%20glass%20with%20tequila%20grapefruit%20syrup%20sparkling%20water%20pink%20coral%20color%20with%20ice%2C%20watercolor%20illustration%20style%2C%20soft%20pink%20coral%20grapefruit%20tones%2C%20white%20background%2C%20artistic%20drink%20painting%2C%20soft%20pastel%20colors%2C%20premium%20cocktail%20art%2C%20grapefruit%20slice%20garnish&width=200&height=260&seq=cocktail11&orientation=portrait',
  },
  {
    name: 'New York Sour',
    ingredients: 'Whisky, Vinho Tinto, Açúcar, Limão, Proteina e Angostura',
    image: 'https://readdy.ai/api/search-image?query=new%20york%20sour%20cocktail%20rocks%20glass%20with%20whiskey%20red%20wine%20float%20on%20top%20two%20layers%20amber%20golden%20below%20deep%20red%20wine%20above%2C%20watercolor%20illustration%20style%2C%20dramatic%20two%20tone%20amber%20red%20tones%2C%20white%20background%2C%20artistic%20drink%20painting%2C%20soft%20pastel%20colors%2C%20premium%20cocktail%20art%2C%20lemon%20garnish&width=200&height=260&seq=cocktail12&orientation=portrait',
  },
  {
    name: 'Libertalia',
    ingredients: 'Limão, Vinho, Gin, Refrigerante de Limão',
    image: 'https://readdy.ai/api/search-image?query=libertalia%20cocktail%20elegant%20wine%20glass%20with%20gin%20wine%20lemon%20soda%20pale%20golden%20rose%20color%20with%20ice%2C%20watercolor%20illustration%20style%2C%20soft%20golden%20rose%20tones%2C%20white%20background%2C%20artistic%20drink%20painting%2C%20soft%20pastel%20colors%2C%20premium%20cocktail%20art%2C%20lemon%20twist%20garnish&width=200&height=260&seq=autoral1&orientation=portrait',
  },
  {
    name: 'La Playa',
    ingredients: 'Limão, Leite de Coco, Rum, Hortelã, Açúcar, Água com Gás',
    image: 'https://readdy.ai/api/search-image?query=la%20playa%20tropical%20cocktail%20tall%20glass%20with%20coconut%20milk%20rum%20mint%20leaves%20lime%20sparkling%20water%20creamy%20white%20green%20color%20with%20ice%2C%20watercolor%20illustration%20style%2C%20soft%20tropical%20cream%20green%20tones%2C%20white%20background%2C%20artistic%20drink%20painting%2C%20soft%20pastel%20colors%2C%20premium%20cocktail%20art%2C%20mint%20lime%20garnish&width=200&height=260&seq=autoral2&orientation=portrait',
  },
  {
    name: 'Goodbye Kiss',
    ingredients: 'Campari, Cachaça, Maracujá, Açúcar',
    image: 'https://readdy.ai/api/search-image?query=goodbye%20kiss%20cocktail%20coupe%20glass%20with%20campari%20cachaca%20passion%20fruit%20sugar%20deep%20ruby%20orange%20red%20color%2C%20watercolor%20illustration%20style%2C%20rich%20ruby%20red%20orange%20tones%2C%20white%20background%2C%20artistic%20drink%20painting%2C%20soft%20pastel%20colors%2C%20premium%20cocktail%20art%2C%20passion%20fruit%20garnish&width=200&height=260&seq=autoral3&orientation=portrait',
  },
  {
    name: 'Pretty Woman',
    ingredients: 'Limão, Vodka, Hortelã, Energético de Melancia',
    image: 'https://readdy.ai/api/search-image?query=pretty%20woman%20cocktail%20tall%20glass%20with%20vodka%20watermelon%20energy%20drink%20mint%20lemon%20vibrant%20pink%20red%20color%20with%20ice%2C%20watercolor%20illustration%20style%2C%20vivid%20pink%20watermelon%20tones%2C%20white%20background%2C%20artistic%20drink%20painting%2C%20soft%20pastel%20colors%2C%20premium%20cocktail%20art%2C%20mint%20watermelon%20garnish&width=200&height=260&seq=autoral4&orientation=portrait',
  },
];

const classicos = [
  {
    name: 'Gin Tônica',
    ingredients: 'Gin, Especiarias e Tonica',
    image: 'https://readdy.ai/api/search-image?query=gin%20tonic%20cocktail%20in%20large%20balloon%20wine%20glass%20with%20ice%20botanicals%20spices%20and%20tonic%20water%2C%20elegant%20watercolor%20illustration%20style%2C%20crystal%20clear%20pale%20golden%20color%2C%20white%20background%2C%20artistic%20drink%20painting%2C%20soft%20pastel%20colors%2C%20premium%20cocktail%20art%2C%20garnished%20with%20botanicals%20and%20citrus%20peel&width=200&height=260&seq=classico1&orientation=portrait',
  },
  {
    name: 'Gin Tropical',
    ingredients: 'Gin, Limão, Energético Tropical, Frutas Cítricas',
    image: 'https://readdy.ai/api/search-image?query=tropical%20gin%20cocktail%20tall%20glass%20with%20citrus%20fruits%20lemon%20lime%20orange%20slices%20energy%20drink%20tropical%20color%20vibrant%20yellow%20green%2C%20watercolor%20illustration%20style%2C%20bright%20tropical%20citrus%20tones%2C%20white%20background%2C%20artistic%20drink%20painting%2C%20soft%20pastel%20colors%2C%20premium%20cocktail%20art%2C%20citrus%20garnish&width=200&height=260&seq=classico8&orientation=portrait',
  },
  {
    name: 'Aperol Spritz',
    ingredients: 'Aperol, Espumante e Água com gás',
    image: 'https://readdy.ai/api/search-image?query=aperol%20spritz%20cocktail%20in%20large%20wine%20glass%20with%20orange%20slice%20and%20ice%2C%20vibrant%20orange%20color%20with%20bubbles%2C%20watercolor%20illustration%20style%2C%20warm%20vivid%20orange%20tones%2C%20white%20background%2C%20artistic%20drink%20painting%2C%20soft%20pastel%20colors%2C%20premium%20cocktail%20art%2C%20orange%20garnish&width=200&height=260&seq=classico2&orientation=portrait',
  },
  {
    name: 'Limoncello Spritz',
    ingredients: 'Limoncello, Espumante e Água com gás',
    image: 'https://readdy.ai/api/search-image?query=limoncello%20spritz%20cocktail%20in%20elegant%20wine%20glass%20with%20lemon%20slice%20and%20ice%2C%20pale%20yellow%20green%20color%20with%20bubbles%2C%20watercolor%20illustration%20style%2C%20soft%20lemon%20yellow%20tones%2C%20white%20background%2C%20artistic%20drink%20painting%2C%20soft%20pastel%20colors%2C%20premium%20cocktail%20art%2C%20lemon%20garnish&width=200&height=260&seq=classico3&orientation=portrait',
  },
  {
    name: 'Clericot',
    ingredients: 'Espumante, Água com gás e Frutas da estação',
    image: 'https://readdy.ai/api/search-image?query=clericot%20cocktail%20wine%20glass%20with%20sparkling%20wine%20strawberries%20and%20seasonal%20fruits%20floating%20inside%2C%20pink%20rose%20color%2C%20watercolor%20illustration%20style%2C%20soft%20pink%20rose%20tones%2C%20white%20background%2C%20artistic%20drink%20painting%2C%20soft%20pastel%20colors%2C%20premium%20cocktail%20art%2C%20fresh%20fruit%20garnish&width=200&height=260&seq=classico4&orientation=portrait',
  },
  {
    name: 'Piña Colada',
    ingredients: 'Rum, Suco de abacaxi, Leite de coco e Leite condensado',
    image: 'https://readdy.ai/api/search-image?query=pina%20colada%20cocktail%20in%20tall%20hurricane%20glass%20with%20pineapple%20slice%20and%20cherry%20on%20top%2C%20creamy%20white%20ivory%20color%2C%20watercolor%20illustration%20style%2C%20soft%20cream%20ivory%20tones%2C%20white%20background%2C%20artistic%20drink%20painting%2C%20soft%20pastel%20colors%2C%20premium%20cocktail%20art%2C%20tropical%20pineapple%20garnish&width=200&height=260&seq=classico5&orientation=portrait',
  },
  {
    name: 'Moscow Mule',
    ingredients: 'Vodka, Limão, Ginger Syrup e Espuma Artesanal exclusiva Barem',
    image: 'https://readdy.ai/api/search-image?query=moscow%20mule%20cocktail%20in%20copper%20mug%20with%20mint%20leaves%20lime%20wedge%20and%20ice%2C%20warm%20copper%20metallic%20mug%2C%20watercolor%20illustration%20style%2C%20warm%20copper%20brown%20tones%2C%20white%20background%2C%20artistic%20drink%20painting%2C%20soft%20pastel%20colors%2C%20premium%20cocktail%20art%2C%20fresh%20mint%20garnish&width=200&height=260&seq=classico6&orientation=portrait',
  },
  {
    name: 'Caipiroska (Escolher a Fruta)',
    ingredients: 'Fruta da estação, Açúcar e Vodka',
    image: 'https://readdy.ai/api/search-image?query=caipiroska%20cocktail%20tall%20glass%20with%20strawberries%20raspberries%20seasonal%20fruit%20muddled%20with%20sugar%20and%20vodka%2C%20vibrant%20red%20pink%20color%20with%20ice%2C%20watercolor%20illustration%20style%2C%20warm%20red%20pink%20tones%2C%20white%20background%2C%20artistic%20drink%20painting%2C%20soft%20pastel%20colors%2C%20premium%20cocktail%20art%2C%20fresh%20fruit%20garnish&width=200&height=260&seq=classico7&orientation=portrait',
  },
  {
    name: 'Caipirinha (Escolher a Fruta)',
    ingredients: 'Fruta da Estação, Açúcar e Cachaça',
    image: 'https://readdy.ai/api/search-image?query=caipirinha%20cocktail%20rocks%20glass%20with%20lime%20lemon%20passion%20fruit%20seasonal%20fruit%20muddled%20with%20sugar%20and%20cachaca%2C%20vibrant%20green%20yellow%20color%20with%20crushed%20ice%2C%20watercolor%20illustration%20style%2C%20fresh%20lime%20green%20golden%20tones%2C%20white%20background%2C%20artistic%20drink%20painting%2C%20soft%20pastel%20colors%2C%20premium%20cocktail%20art%2C%20fresh%20lime%20fruit%20garnish&width=200&height=260&seq=classico9&orientation=portrait',
  },
  {
    name: 'Dry Martini',
    ingredients: 'Gin, Vermute Seco, Azeitona ou Twist de Limão',
    image: 'https://readdy.ai/api/search-image?query=dry%20martini%20cocktail%20elegant%20classic%20martini%20glass%20with%20olive%20garnish%20on%20cocktail%20pick%2C%20crystal%20clear%20pale%20golden%20gin%20vermouth%2C%20watercolor%20illustration%20style%2C%20soft%20golden%20ivory%20tones%2C%20white%20background%2C%20artistic%20drink%20painting%2C%20soft%20pastel%20colors%2C%20premium%20cocktail%20art%2C%20lemon%20twist%20olive%20garnish&width=200&height=260&seq=classico12&orientation=portrait',
  },
  {
    name: 'Cosmopolitan',
    ingredients: 'Vodka, Triple Sec, Suco de Cranberry e Limão Siciliano',
    image: 'https://readdy.ai/api/search-image?query=cosmopolitan%20cocktail%20elegant%20martini%20glass%20with%20vibrant%20pink%20cranberry%20color%2C%20citrus%20garnish%20on%20rim%2C%20watercolor%20illustration%20style%2C%20vivid%20pink%20rose%20tones%2C%20white%20background%2C%20artistic%20drink%20painting%2C%20soft%20pastel%20colors%2C%20premium%20cocktail%20art%2C%20lemon%20twist%20garnish&width=200&height=260&seq=classico10&orientation=portrait',
  },
  {
    name: 'Margarita',
    ingredients: 'Tequila, Triple Sec, Limão e Sal na Borda',
    image: 'https://readdy.ai/api/search-image?query=margarita%20cocktail%20in%20classic%20coupe%20glass%20with%20salted%20rim%2C%20pale%20golden%20lime%20green%20color%20with%20ice%2C%20watercolor%20illustration%20style%2C%20soft%20lime%20golden%20tones%2C%20white%20background%2C%20artistic%20drink%20painting%2C%20soft%20pastel%20colors%2C%20premium%20cocktail%20art%2C%20lime%20wedge%20garnish%20salted%20rim&width=200&height=260&seq=classico11&orientation=portrait',
  },
];

export default function DrinkMenu() {
  return (
    <section
      id="carta-drinks"
      className="py-12 sm:py-20 lg:py-32"
      style={{ background: 'linear-gradient(135deg, #0D0A06 0%, #1A1200 50%, #0D0A06 100%)' }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16 lg:mb-20">
          <p className="text-[#D4AF37] text-xs uppercase tracking-[0.4em] mb-4 font-light">
            Experiências únicas
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light text-white mb-6">
            Carta de Drinks
          </h2>
          <div className="w-16 h-px bg-[#D4AF37] mx-auto mb-6"></div>
          <p className="text-[#AAAAAA] text-sm font-light tracking-wide max-w-xl mx-auto leading-relaxed">
            Drinks autorais e comerciais que fazem sucesso — elaborados para surpreender seus convidados.
          </p>
        </div>

        {/* ── CLÁSSICOS ── */}
        <div className="flex items-center gap-6 mb-10 sm:mb-12 lg:mb-14">
          <div className="flex-1 h-px bg-[#2A2000]"></div>
          <span className="text-[#D4AF37] text-xs uppercase tracking-[0.5em] font-light">Clássicos</span>
          <div className="flex-1 h-px bg-[#2A2000]"></div>
        </div>

        <p className="text-[#AAAAAA] text-xs uppercase tracking-[0.3em] text-center mb-8 sm:mb-10 font-light">
          Os Clássicos mais refrescantes
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-16 sm:mb-20 lg:mb-24">
          {classicos.map((drink, index) => (
            <div
              key={index}
              className="group border border-[#2A2000] hover:border-[#D4AF37] transition-all duration-500 cursor-pointer overflow-hidden"
              style={{ background: 'rgba(212,175,55,0.03)' }}
            >
              <div className="w-full h-56 overflow-hidden bg-black/30 flex items-center justify-center">
                <img
                  src={drink.image}
                  alt={drink.name}
                  className="w-full h-full object-contain p-4 group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="p-5 sm:p-6 lg:p-8 border-t border-[#2A2000] group-hover:border-[#D4AF37] transition-colors duration-500">
                <h3 className="text-white text-base font-medium uppercase tracking-wider mb-3">
                  {drink.name}
                </h3>
                <div className="w-8 h-px bg-[#D4AF37] mb-4"></div>
                <p className="text-[#AAAAAA] text-sm font-light leading-relaxed">
                  {drink.ingredients}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* ── COCKTAILS ── */}
        <div className="flex items-center gap-6 mb-10 sm:mb-12 lg:mb-14">
          <div className="flex-1 h-px bg-[#2A2000]"></div>
          <span className="text-[#D4AF37] text-xs uppercase tracking-[0.5em] font-light">Cocktails</span>
          <div className="flex-1 h-px bg-[#2A2000]"></div>
        </div>

        <p className="text-[#AAAAAA] text-xs uppercase tracking-[0.3em] text-center mb-8 sm:mb-10 font-light">
          Assinaturas autorais exclusivas Barem e Comercial
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-6 sm:mb-8">
          {cocktails.slice(0, 3).map((drink, index) => (
            <div
              key={index}
              className="group border border-[#2A2000] hover:border-[#D4AF37] transition-all duration-500 cursor-pointer overflow-hidden"
              style={{ background: 'rgba(212,175,55,0.03)' }}
            >
              <div className="w-full h-56 overflow-hidden bg-black/30 flex items-center justify-center">
                <img
                  src={drink.image}
                  alt={drink.name}
                  className="w-full h-full object-contain p-4 group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="p-5 sm:p-6 lg:p-8 border-t border-[#2A2000] group-hover:border-[#D4AF37] transition-colors duration-500">
                <h3 className="text-white text-base font-medium uppercase tracking-wider mb-3">
                  {drink.name}
                </h3>
                <div className="w-8 h-px bg-[#D4AF37] mb-4"></div>
                <p className="text-[#AAAAAA] text-sm font-light leading-relaxed">
                  {drink.ingredients}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-6 sm:mb-8">
          {cocktails.slice(3, 6).map((drink, index) => (
            <div
              key={index}
              className="group border border-[#2A2000] hover:border-[#D4AF37] transition-all duration-500 cursor-pointer overflow-hidden"
              style={{ background: 'rgba(212,175,55,0.03)' }}
            >
              <div className="w-full h-56 overflow-hidden bg-black/30 flex items-center justify-center">
                <img
                  src={drink.image}
                  alt={drink.name}
                  className="w-full h-full object-contain p-4 group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="p-5 sm:p-6 lg:p-8 border-t border-[#2A2000] group-hover:border-[#D4AF37] transition-colors duration-500">
                <h3 className="text-white text-base font-medium uppercase tracking-wider mb-3">
                  {drink.name}
                </h3>
                <div className="w-8 h-px bg-[#D4AF37] mb-4"></div>
                <p className="text-[#AAAAAA] text-sm font-light leading-relaxed">
                  {drink.ingredients}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-6 sm:mb-8">
          {cocktails.slice(6, 9).map((drink, index) => (
            <div
              key={index}
              className="group border border-[#2A2000] hover:border-[#D4AF37] transition-all duration-500 cursor-pointer overflow-hidden"
              style={{ background: 'rgba(212,175,55,0.03)' }}
            >
              <div className="w-full h-56 overflow-hidden bg-black/30 flex items-center justify-center">
                <img
                  src={drink.image}
                  alt={drink.name}
                  className="w-full h-full object-contain p-4 group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="p-5 sm:p-6 lg:p-8 border-t border-[#2A2000] group-hover:border-[#D4AF37] transition-colors duration-500">
                <h3 className="text-white text-base font-medium uppercase tracking-wider mb-3">
                  {drink.name}
                </h3>
                <div className="w-8 h-px bg-[#D4AF37] mb-4"></div>
                <p className="text-[#AAAAAA] text-sm font-light leading-relaxed">
                  {drink.ingredients}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-16 sm:mb-20 lg:mb-24">
          {cocktails.slice(9).map((drink, index) => (
            <div
              key={index}
              className="group border border-[#2A2000] hover:border-[#D4AF37] transition-all duration-500 cursor-pointer overflow-hidden"
              style={{ background: 'rgba(212,175,55,0.03)' }}
            >
              <div className="w-full h-56 overflow-hidden bg-black/30 flex items-center justify-center">
                <img
                  src={drink.image}
                  alt={drink.name}
                  className="w-full h-full object-contain p-4 group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="p-5 sm:p-6 lg:p-8 border-t border-[#2A2000] group-hover:border-[#D4AF37] transition-colors duration-500">
                <h3 className="text-white text-base font-medium uppercase tracking-wider mb-3">
                  {drink.name}
                </h3>
                <div className="w-8 h-px bg-[#D4AF37] mb-4"></div>
                <p className="text-[#AAAAAA] text-sm font-light leading-relaxed">
                  {drink.ingredients}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* ── MOCKTAILS ── */}
        <div className="flex items-center gap-6 mb-10 sm:mb-12 lg:mb-14">
          <div className="flex-1 h-px bg-[#2A2000]"></div>
          <span className="text-[#D4AF37] text-xs uppercase tracking-[0.5em] font-light">Mocktails</span>
          <div className="flex-1 h-px bg-[#2A2000]"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {mocktails.map((drink, index) => (
            <div
              key={index}
              className="group border border-[#2A2000] hover:border-[#D4AF37] transition-all duration-500 cursor-pointer overflow-hidden"
              style={{ background: 'rgba(212,175,55,0.03)' }}
            >
              <div className="w-full h-56 overflow-hidden bg-black/30 flex items-center justify-center">
                <img
                  src={drink.image}
                  alt={drink.name}
                  className="w-full h-full object-contain p-4 group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="p-5 sm:p-6 lg:p-8 border-t border-[#2A2000] group-hover:border-[#D4AF37] transition-colors duration-500">
                <h3 className="text-white text-base font-medium uppercase tracking-wider mb-3">
                  {drink.name}
                </h3>
                <div className="w-8 h-px bg-[#D4AF37] mb-4"></div>
                <p className="text-[#AAAAAA] text-sm font-light leading-relaxed">
                  {drink.ingredients}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Rodapé da seção */}
        <div className="mt-12 sm:mt-16 text-center">
          <p className="text-[#D4AF37] text-sm font-light tracking-widest uppercase">
            Drinks autorais e comerciais que fazem sucesso
          </p>
        </div>
      </div>
    </section>
  );
}
